module.exports = __webpack_public_path__ + "96cd2adef79549cf87fb2e74ec80c4a9.svg";